<template>
    <div class="operate_right blue">
        <div class="or_title">
            本日保障内容
        </div>
        <div class="table_box">
            <div class="table_tab">
                <div class="i_tab">
                    <div class="tab_item HuXiaoBo" @click.prevent="changTab('超低保障')" :class="{ isChoose: isChoose }">
                        <span>超低保障</span>
                    </div>
                    <!-- @click.prevent="changTab('降本管理')" -->
                    <div class="tab_item HuXiaoBo disabled" :class="{ isChoose: !isChoose }">
                        <span>降本管理</span>
                    </div>
                </div>
                <div class="show_detail HuXiaoBo" @click="downloadFile">
                    查看详情 》
                </div>
            </div>
            <el-table :data="tableData" stripe style="width: 100%" height="100%">
                <el-table-column prop="typeName" label="设备类型" align="center" width="170">
                </el-table-column>
                <el-table-column prop="deviceName" label="设备名称" align="center" width="170">
                </el-table-column>
                <el-table-column prop="deviceNo" label="设备编码" align="center" width="170">
                </el-table-column>
                <el-table-column prop="ticketTypeName" label="保障类型" align="center" width="170">
                </el-table-column>
                <el-table-column prop="taskStatusDesc" label="处理结果" align="center" width="170">
                </el-table-column>
            </el-table>
        </div>
        <div class="page_box">
            <el-pagination @current-change="handleCurrentChange" background :current-page="paramsList.pageNo" :page-size="paramsList.pageSize" layout="total,prev, pager, next, jumper" :total="page_total" :pager-count="4"></el-pagination>
        </div>
    </div>
</template>

<script>
import jsonData from '/public/static/js/json/operatieCenter.json';
import { dateFormat } from "utils/tools";
export default {
    name: 'index',
    data () {
        return {
            isChoose: true,
            chooseName: '',
            page_total: 0,
            showData: [],
            tableData: [],
            paramsList: {
                pageNo: 1,
                pageSize: 50,
            },
            dateArr: [
                new Date(new Date().setHours(0, 0, 0, 0)),
                new Date(),
            ],
        }
    },
    created () {
        this.getTableData();
    },
    mounted () {
        // this.showData = jsonData.todayGuarantee.ultraLow;

    },
    methods: {
        downloadFile () {
            // const a = document.createElement('a');
            // a.setAttribute('href', 'download/');
            // a.setAttribute('download', '超低保障.xlsx');
            // a.click();

            this.$store.commit("upDateOperationCenterDialog", { state: true, params: { type: '维护事件', value: '999' } });

        },
        changTab (type) {
            // this.isChoose = !this.isChoose;
            this.chooseName = type;
            if (type === '超低保障') {
                this.getTableData()
            } else {
                this.tableData = []
            }
        },
        // getTableData() {
        //   let start;
        //   let end;
        //   if (this.paramsList.pageNo === 1) {
        //     start = 0;
        //     end = this.paramsList.pageSize;
        //   } else {
        //     start = (this.paramsList.pageNo - 1) * this.paramsList.pageSize + 1;
        //     end = start + this.paramsList.pageSize;
        //   }
        //   this.tableData = this.showData.slice(start, end);
        // },
        async getTableData () {
            let that = this
            let params = { ...this.paramsList }
            let url = ''
            params.startTime = Date.parse(this.dateArr[0])
            params.endTime = Date.parse(this.dateArr[1])
            params.customerId = that.$store.state.customerId
            params.branchFactoryId = ''
            params.productLineId = ''
            params.primaryTypeId = ''
            params.typeId = ''
            params.deviceName = null
            params.ticketType = null // 工单类型
            params.taskStatus = null // 任务状态
            params.type = '',
            params.auditPass = 1
            url = CONFIG.requestName + this.$apiOpt.getRelationList;
            this.$apiUtils
                .get(url, params)
                .then(data => {
                    that.tableData = data.records || []
                    that.page_total = data.total || 0
                    // if (data.length > 0) {
                    //     that.tableData = data.records || []
                    //     that.page_total = data.total || 0
                    // } else {
                    //     let data = {
                    //         "pages": 1,
                    //         "size": 20,
                    //         "total": 1,
                    //         "current": 1,
                    //         "records": [
                    //             {
                    //                 "rowKey": "210-CC-LZ-GTDQ0037BDCC-LX9223370350721566230",
                    //                 "taskNo": "BDCC-LX003716861332095770466",
                    //                 "customerId": 37,
                    //                 "customerName": "青岛特钢",
                    //                 "areaId": 1,
                    //                 "areaName": "华东",
                    //                 "taskResource": 5,
                    //                 "taskResourceName": "客户自查",
                    //                 "branchFactoryId": 102296,
                    //                 "branchFactoryName": null,
                    //                 "productLineId": 102312,
                    //                 "productLine": null,
                    //                 "primaryTypeId": 2,
                    //                 "primaryTypeName": null,
                    //                 "typeId": 1539730887855002,
                    //                 "typeName": "布袋除尘器",
                    //                 "ticketType": "LX",
                    //                 "ticketTypeName": "数据离线处理",
                    //                 "ticketCode": "BDCC-LX",
                    //                 "deviceNo": "QDTG-ZL-CC-012",
                    //                 "deviceName": "烧结成品筛分除尘设施",
                    //                 "description": null,
                    //                 "taskStatus": 2,
                    //                 "taskStatusDesc": "待审核",
                    //                 "reportDec": null,
                    //                 "createTime": "2023-06-07 18:20:09",
                    //                 "remark": null
                    //             }
                    //         ]
                    //     }
                    //     that.tableData = data.records || []
                    //     that.page_total = data.total || 0
                    // }

                });
        },
        handleCurrentChange (val) {
            this.paramsList.pageNo = val;
            this.getTableData();
        }
    }
}
</script>

<style lang="scss" scoped>
.operate_right {
    transition: none 0s ease 0s;
    padding-top: 10px;
    height: 100%;
    margin-left: 20px;
    padding-left: 15px;
    padding-right: 15px;
    @include bg-box(100%, 100%, "right.png");
    display: flex;
    flex-direction: column;
    .or_title {
        font-size: 30px;
        color: #63f2ef;
        padding-left: 20px;
        font-weight: 600;
    }
    .isBaoSteel {
        background: #020f3f;
    }
    .box_wrap {
        height: 100%;
    }
    .or_title {
        display: flex;
        .show_more {
            margin-left: auto;
            font-size: 20px;
            margin-right: 10px;
        }
    }
    .table_box {
        // margin-top:20px;
        background: transparent;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        flex: 1;
        padding: 20px 10px 10px;
        .table_tab {
            display: flex;
            margin-bottom: 5px;
            font-size: 22px;
            background: #141c5b;
            align-items: center;
            .i_tab {
                display: flex;
                width: 70%;
                border-radius: 30px;
                border: 1px solid;

                .tab_item {
                    display: flex;
                    flex: 1;
                    justify-content: center;
                    border-radius: 30px;
                    cursor: pointer;
                    line-height: 35px;
                }
                .disabled {
                    color: #969998;
                }
                .isChoose {
                    @include bg-box(100%, 35px, "tabItem.png");
                    background-size: inherit;
                }
            }
            .show_detail {
                margin-left: auto;
                color: #64c6ef;
                cursor: pointer;
            }
        }

        .el-table {
            background: transparent;
        }
        :deep(.el-table) {
            th > .cell {
                color: #49d9d2 !important;
                font-size: 20px;
            }

            tbody {
                .cell {
                    color: #c6d6df;
                }
                .el-table__row {
                    background: linear-gradient(
                        180deg,
                        rgba(108, 151, 255, 0.2) 0%,
                        rgba(107, 151, 255, 0.1988) 48%,
                        rgba(58, 116, 255, 0.1) 100%,
                        rgba($color: #0049fa, $alpha: 0.7) 100%,
                        rgba($color: #0049fa, $alpha: 0.7) 100%
                    );
                    // border: 1px solid #8BADFF;
                    td {
                        border-bottom: 1px solid #8badff;
                    }
                }

                .el-table__row--striped {
                    background: linear-gradient(
                        180deg,
                        rgba(108, 151, 255, 0.2) 0%,
                        rgba(107, 151, 255, 0.1988) 48%,
                        rgba(58, 116, 255, 0.1) 100%,
                        #0049fa 100%,
                        #0049fa 100%
                    ) !important;
                    td {
                        border-bottom: 1px solid #8badff;
                    }
                }
            }
        }
        :deep(.el-table__header) {
            width: auto !important;
            .has-gutter {
                height: 50px;
                background: transparent;
                // filter: blur(38.08000183105469px);
                border: 1px solid #84aaff;
                tr th {
                    background: linear-gradient(
                        180deg,
                        rgba(108, 151, 255, 0.2) 0%,
                        rgba(107, 151, 255, 0.1988) 48%,
                        rgba(58, 116, 255, 0.1) 100%,
                        #0049fa 100%,
                        #0049fa 100%
                    );
                    border-bottom: 1px solid #8badff;
                }
            }
        }
        :deep(.el-table th > .cell) {
            white-space: initial;
            overflow: initial;
            font-size: 24px;
            color: #47ffdd !important;
        }
        :deep(.el-table__body) {
            width: auto !important;
        }
        :deep(.el-table__body-wrapper) {
            overflow-x: hidden;
            .el-table__empty-block {
                width: auto !important;
            }
        }
    }
    .page_box {
        width: 100%;
        // margin-top: 10px;
        padding-bottom: 20px;
        :deep(.el-pager) {
            li {
                background-color: transparent !important;
            }
        }
        :deep(.el-pagination) {
            padding-right: 50px !important;
            font-size: 29px !important;
            button {
                height: 28px !important;
                line-height: 28px !important;
                width: 10px;
            }
            li {
                height: 28px !important;
                line-height: 28px !important;
                width: 40px !important;
                font-size: 22px !important;
                color: #fff;
            }
            li:not(.disabled).active {
                color: #32c5ff;
            }
            .btn-prev {
                background: none !important ;
                color: white !important;
            }

            .btn-next {
                background: none !important;
                color: white !important;
            }
            .el-pagination__total {
                font-size: 22px !important;
            }
            .el-pagination__jump {
                font-size: 22px !important;
            }
        }
    }
}
.blue {
    border: 1px solid rgba(132, 170, 255, 0.5);
}
.operate_right :deep(.el-pagination) {
    span:not([class*="suffix"]),
    .el-pagination button {
        line-height: 32px;
        font-size: 16px;
    }
}

.operate_right :deep(.el-pagination__editor) {
    .el-input__inner {
        font-size: 20px;
        height: 32px;
        background: rgba(0, 0, 0, 0.2002);
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        border: 1px solid #32c5ff;
    }
}

.operate_right :deep(.el-table) {
    &::before {
        height: 0px !important;
    }
}
</style>

